import _ from 'underscore'

export const makeGroup = (originalGroup) => {
  const { groupName, isPartOfGroup, items, labels, totalCount } = originalGroup
  const isValidItemsArray = Array.isArray(items)
  const calculateTotalCount = () => (isValidItemsArray ? items.length : 0)

  return {
    groupName: groupName || '',
    isPartOfGroup: isPartOfGroup || false,
    items: isValidItemsArray ? items : [],
    labels: labels || [],
    totalCount: typeof totalCount === 'number' ? totalCount : calculateTotalCount(),
  }
}

/**
 * Groups items by the given properties.
 *
 * @param {object[]} allItems - An array of objects
 * @param {(function|string)[]} groupByProperties - A collection of property names and/or getter functions
 * @return {object[]} A Group collection, each containing items relevant to that group.
 */
export const groupBy = (allItems, groupByProperties) => {
  const hasData = groupByProperties?.length && allItems?.length

  if (!hasData) {
    return [
      makeGroup({ items: allItems }),
    ]
  }

  const groupedItems = allItems.reduce((groupSet, item) => {
    const { groupName, groupValues } = groupByProperties.reduce((groupData, propertyName) => {
      const isFunction = typeof propertyName === 'function'
      const groupValue = isFunction ? propertyName(item) : item[propertyName]

      groupData.groupName += groupValue
      groupData.groupValues.push(groupValue)

      return groupData
    }, { groupName: '', groupValues: [] })

    if (!groupSet[groupName]) {
      groupSet[groupName] = makeGroup({
        groupName,
        labels: groupValues,
        isPartOfGroup: true,
        items: [],
        totalCount: 0,
      })
    }

    groupSet[groupName].items.push(item)
    groupSet[groupName].totalCount = groupSet[groupName].items.length

    return groupSet
  }, {})

  const groupsArray = Object.keys(groupedItems).map((groupKey) => groupedItems[groupKey])
  const sortedGroups = _.sortAscByCaseInsensitive(groupsArray, 'groupName')

  return sortedGroups
}
